<template>
  <div class="trialEnterpriseContact">
    <p class="title">请联系工作人员开通试用账号</p>
    <p class="phoneNumber">
      <i class="el-icon-phoneNumber"></i>
      <span>联系电话：010-81720072</span>
    </p>
    <el-button type="primary" size="small" @click="copyPhoneNumber">复制手机号</el-button>
  </div>
</template>

<script>
export default {
  methods: {
    copyPhoneNumber() {
      this.$copyText("010-81720072").then(() => {
        this.$message.success("手机号复制成功！");
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.trialEnterpriseContact {
  text-align: center;
  .title {
    font-size: 22px;
    color: var(--key-color);
  }
  .phoneNumber {
    margin-top: 22px;
    margin-bottom: 22px;
    span {
      font-size: 16px;
      color: var(--theme-color);
      vertical-align: top;
      margin-left: 5px;
    }
  }
  /deep/ .el-icon-phoneNumber {
    background: url("./img/number.png") no-repeat;
    width: 20px;
    height: 20px;
  }

  /deep/ .el-icon-phoneNumber:before {
    content: "替";
    font-size: 13px;
    visibility: hidden;
  }
}
</style>
